import { useState, useEffect } from 'react';
import { getGiftCardsAmount } from '../services/gifting';
import { mapAmountIntoCard } from '../pages/Gift/helpers';
import { fallbackPriceCards } from '../pages/Gift/constants';

const useGiftCards = () => {
  const [giftCards, setGiftCards] = useState([]);
  const [selectedGiftCard, setSelectedGiftCard] = useState({ id: '', value: null, label: '' });
  const selectGiftCard = (card) => setSelectedGiftCard(card);

  useEffect(() => {
    getGiftCardsAmount()
      .then(({ options }) => {
        const cards = mapAmountIntoCard(options);
        setGiftCards(cards);
        setSelectedGiftCard(cards[0]);
      })
      .catch((error) => {
        setGiftCards(fallbackPriceCards);
        setSelectedGiftCard(fallbackPriceCards[0]);
        console.log(error);
      });
  }, []);

  return { giftCards, selectedGiftCard, selectGiftCard };
};

export default useGiftCards;
